{
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "الرجاء اختيار محادثة من قائمة المحادثات",
    "CSAT_REPLY_MESSAGE": "الرجاء تقييم المحادثة",
    "404": "عذراً، لا يمكننا العثور على المحادثة. الرجاء المحاولة مرة أخرى",
    "SWITCH_VIEW_LAYOUT": "تبديل التصميم",
    "DASHBOARD_APP_TAB_MESSAGES": "الرسائل",
    "UNVERIFIED_SESSION": "لم يتم التحقق من هوية هذا المستخدم",
    "NO_MESSAGE_1": "لا توجد رسائل بعد من العملاء في صندوق الوارد الخاص بك.",
    "NO_MESSAGE_2": " لإرسال رسالة إلى الصفحة الخاصة بك!",
    "NO_INBOX_1": "يبدو أنك لم تقم بإضافة أي صناديق بريدية بعد.",
    "NO_INBOX_2": " للبدء",
    "NO_INBOX_AGENT": "يبدو أنه لم يتم إسنادك لأي قنوات تواصل بعد. الرجاء التواصل مع المدير لإضافتك لصناديق الوارد الخاصة بقنوات التواصل",
    "SEARCH_MESSAGES": "ابحث عن رسائل في المحادثات",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "EMPTY_STATE": {
      "CMD_BAR": "لفتح قائمة الأوامر",
      "KEYBOARD_SHORTCUTS": "لعرض اختصارات لوحة المفاتيح"
    },
    "SEARCH": {
      "TITLE": "البحث في الرسائل",
      "RESULT_TITLE": "نتائج البحث",
      "LOADING_MESSAGE": "جار تجزئة البيانات...",
      "PLACEHOLDER": "اكتب أي نص للبحث في الرسائل",
      "NO_MATCHING_RESULTS": "لم يتم العثور على النتائج."
    },
    "UNREAD_MESSAGES": "الرسائل الغير مقروءة",
    "UNREAD_MESSAGE": "رسالة غير مقروءة",
    "CLICK_HERE": "اضغط هنا",
    "LOADING_INBOXES": "جار جلب صناديق الوارد",
    "LOADING_CONVERSATIONS": "جاري جلب المحادثات",
    "CANNOT_REPLY": "لا يمكنك الرد بسبب",
    "24_HOURS_WINDOW": "قيد نافذة الـ 24 ساعة",
    "48_HOURS_WINDOW": "قيد نافذة الـ 48 ساعة",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "NOT_ASSIGNED_TO_YOU": "لم يتم تعيين هذه المحادثة لك. هل ترغب في تعيين هذه المحادثة لنفسك؟",
    "ASSIGN_TO_ME": "إسناد لي",
    "BOT_HANDOFF_MESSAGE": "You are responding to a conversation which is currently handled by an assistant or a bot.",
    "BOT_HANDOFF_ACTION": "Mark open and assign to you",
    "BOT_HANDOFF_REOPEN_ACTION": "Mark conversation open",
    "BOT_HANDOFF_SUCCESS": "Conversation has been handed over to you",
    "BOT_HANDOFF_ERROR": "Failed to take over the conversation. Please try again.",
    "TWILIO_WHATSAPP_CAN_REPLY": "يمكنك فقط الرد على هذه المحادثة باستخدام رسالة قالب بسبب",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "قيد نافذة الـ 24 ساعة",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won’t be able to send messages from this conversation anymore.",
    "REPLYING_TO": "أنت ترد على:",
    "REMOVE_SELECTION": "إزالة التحديد",
    "DOWNLOAD": "تحميل",
    "UNKNOWN_FILE_TYPE": "ملف غير معروف",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file",
      "MEETING": "بدأ {sender} اجتماعاً"
    },
    "UPLOADING_ATTACHMENTS": "جاري رفع المرفقات...",
    "REPLIED_TO_STORY": "رد على قصتك",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "هذه الرسالة غير مدعومة، يمكنك مشاهدة هذه الرسالة على تطبيق فيسبوك (Messenger).",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "هذه الرسالة غير مدعومة، يمكنك عرض هذه الرسالة على تطبيق Instagram.",
    "UNSUPPORTED_MESSAGE_TIKTOK": "هذه الرسالة غير مدعومة. يمكنك مشاهدة هذه الرسالة على تطبيق TikTok.",
    "UNSUPPORTED_MESSAGE_WHATSAPP": "This message is unsupported. You can view this message on the WhatsApp app.",
    "SUCCESS_DELETE_MESSAGE": "تم حذف الرسالة بنجاح",
    "FAIL_DELETE_MESSSAGE": "تعذر حذف الرسالة! حاول مرة أخرى",
    "NO_RESPONSE": "لا توجد استجابة",
    "RESPONSE": "Response",
    "RATING_TITLE": "التقييم",
    "FEEDBACK_TITLE": "الملاحظات",
    "REPLY_MESSAGE_NOT_FOUND": "الرسالة غير متوفرة",
    "CARD": {
      "SHOW_LABELS": "إظهار السمات",
      "HIDE_LABELS": "إخفاء السمات",
      "LABELS_COUNT": "{count} علامة"
    },
    "VOICE_CALL": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NO_ANSWER": "No answer",
      "NO_ANSWER_OUTBOUND_LABEL": "No answer",
      "NO_ANSWER_OUTBOUND_SUBTEXT": "Contact didn't pick up",
      "MISSED_CALL": "Missed call",
      "MISSED_CALL_INBOUND_SUBTEXT": "No agent picked up",
      "MISSED_CALL_DECLINED_BY": "Declined by {agentName}",
      "CALL_ENDED": "Call ended",
      "HANDLED_BY": "Handled by {agentName}",
      "NOT_ANSWERED_YET": "Not answered yet",
      "CALLING": "Calling…",
      "THEY_ANSWERED": "They answered",
      "YOU_ANSWERED": "You answered",
      "AGENT_ANSWERED": "{agentName} answered",
      "JOIN_CALL": "انضم إلى المكالمة",
      "CALL_BACK": "Call back",
      "TRANSCRIPT_SHOW_MORE": "Show more",
      "TRANSCRIPT_SHOW_LESS": "Show less"
    },
    "HEADER": {
      "RESOLVE_ACTION": "حل المحادثة",
      "REOPEN_ACTION": "إعادة فتح",
      "OPEN_ACTION": "فتح",
      "MORE_ACTIONS": "More actions",
      "OPEN": "المزيد",
      "CLOSE": "أغلق",
      "DETAILS": "التفاصيل",
      "COPY_ID_SUCCESS": "Conversation ID copied to clipboard",
      "SNOOZED_UNTIL": "غفوة حتى",
      "SNOOZED_UNTIL_TOMORROW": "تأجيل حتى الغد",
      "SNOOZED_UNTIL_NEXT_WEEK": "تأجيل حتى الأسبوع القادم",
      "SNOOZED_UNTIL_NEXT_REPLY": "تأجيل حتى الرد التالي",
      "WHATSAPP_CALL": "Start WhatsApp call",
      "WHATSAPP_CALL_FAILED": "Could not start the WhatsApp call.",
      "VOICE_CALL": "Start call",
      "VOICE_CALL_FAILED": "Could not start the call.",
      "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
      "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "مفقود",
        "DUE": "مستحق"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "تحديد كمعلق",
      "SNOOZE_UNTIL": "غفوة",
      "SNOOZE": {
        "TITLE": "تأجيل حتى",
        "NEXT_REPLY": "الرد القادم",
        "TOMORROW": "غداً",
        "NEXT_WEEK": "الأسبوع القادم"
      }
    },
    "MENTION": {
      "AGENTS": "الوكلاء",
      "TEAMS": "الفرق"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "تأجيل حتى",
      "APPLY": "تأجيل",
      "CANCEL": "إلغاء"
    },
    "PRIORITY": {
      "TITLE": "الأولوية",
      "OPTIONS": {
        "NONE": "لا يوجد",
        "URGENT": "عاجل",
        "HIGH": "عالية",
        "MEDIUM": "متوسطة",
        "LOW": "منخفضة"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "لا يوجد",
        "INPUT_PLACEHOLDER": "تحديد الأولوية",
        "NO_RESULTS": "لم يتم العثور على النتائج",
        "SUCCESSFUL": "تغيير أولوية معرف المحادثة {conversationId} إلى {priority}",
        "FAILED": "تعذر تغيير الأولوية، الرجاء المحاولة مرة أخرى."
      }
    },
    "DELETE_CONVERSATION": {
      "TITLE": "Delete conversation #{conversationId}",
      "DESCRIPTION": "Are you sure you want to delete this conversation?",
      "CONFIRM": "حذف"
    },
    "CARD_CONTEXT_MENU": {
      "PENDING": "تحديد كمعلق",
      "RESOLVED": "تحديد كمحلولة",
      "MARK_AS_UNREAD": "وضع علامة كغير مقروء",
      "MARK_AS_READ": "تحديد كمقروء",
      "REOPEN": "إعادة فتح المحادثة",
      "SNOOZE": {
        "TITLE": "تأجيل",
        "NEXT_REPLY": "حتى الرد القادم",
        "TOMORROW": "حتى الغد",
        "NEXT_WEEK": "حتى الأسبوع القادم"
      },
      "ASSIGN_AGENT": "تعيين وكيل",
      "ASSIGN_LABEL": "إضافة وسم",
      "AGENTS_LOADING": "جاري جلب الوكلاء...",
      "ASSIGN_TEAM": "تعيين فريق",
      "DELETE": "Delete conversation",
      "OPEN_IN_NEW_TAB": "Open in new tab",
      "COPY_LINK": "Copy conversation link",
      "COPY_LINK_SUCCESS": "Conversation link copied to clipboard",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "معرف المحادثة {conversationId} تم تعيينه لـ \"{agentName}\"",
          "FAILED": "تعذر تعيين الوكيل. الرجاء المحاولة مرة أخرى."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "تعيين تسمية #{labelName} لمعرف المحادثة {conversationId}",
          "FAILED": "تعذر تعيين التسمية. الرجاء المحاولة مرة أخرى."
        },
        "LABEL_REMOVAL": {
          "SUCCESFUL": "Removed label #{labelName} from conversation id {conversationId}",
          "FAILED": "Couldn't remove label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "الفريق المعين \"{team}\" لمعرف المحادثة {conversationId}",
          "FAILED": "تعذر تعيين الفريق. الرجاء المحاولة مرة أخرى."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "توقيع الرسالة",
      "ENABLE_SIGN_TOOLTIP": "تفعيل التوقيع",
      "DISABLE_SIGN_TOOLTIP": "تعطيل التوقيع",
      "MSG_INPUT": "زر Shift + Enter لإضافة سطر جديد. ابدأ بزر / للاختيار من الردود الجاهزة.",
      "PRIVATE_MSG_INPUT": "زر Shift + Enter لإضافة سطر جديد. سيكون هذا مرئياً للوكلاء فقط",
      "MESSAGING_RESTRICTED": "You cannot reply to this conversation",
      "MESSAGING_RESTRICTED_WHATSAPP": "You can only reply using a template message due to 24-hour message window restriction",
      "MESSAGING_RESTRICTED_API": "You can only reply using a template message due to message window restriction",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "لم يتم تكوين توقيع الرسالة، الرجاء تكوينه في إعدادات الملف الشخصي.",
      "COPILOT_MSG_INPUT": "إعطاء copilot أوامر إضافية، أو السؤال عن أي شيء آخر... اضغط على مفتاح الإدخال لإرسال المتابعة",
      "CLICK_HERE": "انقر هنا للتحديث",
      "WHATSAPP_TEMPLATES": "قوالب الواتساب"
    },
    "REPLYBOX": {
      "REPLY": "إضافة رد",
      "PRIVATE_NOTE": "إضافة ملاحظة خاصة",
      "SEND": "إرسال",
      "CREATE": "إضافة ملاحظة",
      "INSERT_READ_MORE": "اقرأ المزيد",
      "DISMISS_REPLY": "استبعاد الرد",
      "REPLYING_TO": "الرد على:",
      "TIP_EMOJI_ICON": "إظهار قائمة الرموز التعبيرية",
      "TIP_ATTACH_ICON": "إرفاق الملفات",
      "TIP_AUDIORECORDER_ICON": "تسجيل الصوت",
      "TIP_AUDIORECORDER_PERMISSION": "السماح بالوصول إلى الصوت",
      "TIP_AUDIORECORDER_ERROR": "تعذر فتح الصوت",
      "AUDIO_CONVERSION_FAILED": "Audio conversion failed. Please try again.",
      "DRAG_DROP": "اسحب و أسقط هنا للإرفاق",
      "START_AUDIO_RECORDING": "بدء التسجيل الصوتي",
      "STOP_AUDIO_RECORDING": "إيقاف التسجيل الصوتي",
      "COPILOT_THINKING": "Copilot يفكر",
      "EMAIL_HEAD": {
        "TO": "إلى",
        "ADD_BCC": "إضافة bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "عناوين البريد الإلكتروني مفصولة بفاصلة",
          "ERROR": "الرجاء إدخال عنوان بريد إلكتروني صحيح"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "عناوين البريد الإلكتروني مفصولة بفاصلة",
          "ERROR": "الرجاء إدخال عنوان بريد إلكتروني صحيح"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "متغيرات غير معرفة",
        "MESSAGE": "لديك {undefinedVariablesCount} متغيرات غير محددة في رسالتك: {undefinedVariables}. هل ترغب في إرسال الرسالة على أي حال؟",
        "CONFIRM": {
          "YES": "إرسال",
          "CANCEL": "إلغاء"
        }
      },
      "QUOTED_REPLY": {
        "ENABLE_TOOLTIP": "Include quoted email thread",
        "DISABLE_TOOLTIP": "Don't include quoted email thread",
        "REMOVE_PREVIEW": "Remove quoted email thread",
        "COLLAPSE": "Collapse preview",
        "EXPAND": "Expand preview"
      }
    },
    "VISIBLE_TO_AGENTS": "ملاحظة خاصة: مرئية فقط لك ولأعضاء فريقك",
    "CHANGE_STATUS": "تم تغيير حالة المحادثة",
    "CHANGE_STATUS_FAILED": "فشل تغيير حالة المحادثة",
    "CHANGE_AGENT": "تم تغيير الوكيل الذي تم إحالة المحادثة إليه",
    "CHANGE_AGENT_FAILED": "فشل تغيير المحال إليه",
    "ASSIGN_LABEL_SUCCESFUL": "تم تعيين الوسم بنجاح",
    "ASSIGN_LABEL_FAILED": "فشل تعيين الوسم",
    "CHANGE_TEAM": "تم تغيير فريق المحادثة",
    "SUCCESS_DELETE_CONVERSATION": "Conversation deleted successfully",
    "FAIL_DELETE_CONVERSATION": "Couldn't delete conversation! Try again",
    "FILE_SIZE_LIMIT": "حجم الملف يتجاوز حد الاقصى وهو {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE}",
    "FILE_TYPE_NOT_SUPPORTED": "هذا النوع من الملفات {fileName} غير مدعوم في هذه المحادثة",
    "MESSAGE_ERROR": "غير قادر على إرسال هذه الرسالة، الرجاء المحاولة مرة أخرى لاحقاً",
    "SENT_BY": "أرسلت بواسطة:",
    "BOT": "رد آلي",
    "NATIVE_APP": "تطبيق الجوال",
    "NATIVE_APP_ADVISORY": "تم إرسال هذه الرسالة من تطبيق الجوال. رد من Chatwoot للحفاظ على نافذة الرسالة.",
    "SEND_FAILED": "تعذر إرسال الرسالة! حاول مرة أخرى",
    "TRY_AGAIN": "إعادة المحاولة",
    "ASSIGNMENT": {
      "SELECT_AGENT": "اختر وكيل",
      "REMOVE": "حذف",
      "ASSIGN": "تكليف"
    },
    "CONTEXT_MENU": {
      "COPY": "نسخ",
      "REPLY_TO": "الرد على هذه الرسالة",
      "DELETE": "حذف",
      "CREATE_A_CANNED_RESPONSE": "إضافة إلى الردود الجاهزة",
      "TRANSLATE": "ترجم",
      "COPY_PERMALINK": "نسخ الرابط إلى الرسالة",
      "LINK_COPIED": "تم نسخ عنوان URL للرسالة إلى الحافظة",
      "DELETE_CONFIRMATION": {
        "TITLE": "هل أنت متأكد من أنك تريد حذف هذه الرسالة؟",
        "MESSAGE": "لا يمكنك التراجع عن هذا الإجراء",
        "DELETE": "حذف",
        "CANCEL": "إلغاء"
      }
    },
    "SIDEBAR": {
      "CONTACT": "جهات الاتصال",
      "COPILOT": "Copilot"
    },
    "VOICE_WIDGET": {
      "INCOMING_CALL": "مكالمة واردة",
      "OUTGOING_CALL": "مكالمة صادرة",
      "CALL_IN_PROGRESS": "مكالمة قيد الاتصال",
      "NOT_ANSWERED_YET": "لم يتم الرد بعد",
      "HANDLED_IN_ANOTHER_TAB": "يتم التعامل معها في علامة تبويب أخرى",
      "REJECT_CALL": "رفض",
      "DISMISS_CALL": "تجاهل",
      "JOIN_CALL": "انضم إلى المكالمة",
      "END_CALL": "إنهاء المكالمة",
      "MUTE": "Mute mic",
      "UNMUTE": "Unmute mic",
      "VIEW_CHAT_HISTORY": "View chat history",
      "GO_TO_CONVERSATION": "Go to conversation thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "إرسال نص المحادثة",
    "DESC": "إرسال نسخة من نص المحادثة إلى عنوان البريد الإلكتروني المحدد",
    "SUBMIT": "إرسال",
    "CANCEL": "إلغاء",
    "SEND_EMAIL_SUCCESS": "تم إرسال نص المحادثة بنجاح",
    "SEND_EMAIL_ERROR": "حدث خطأ، الرجاء المحاولة مرة أخرى",
    "SEND_EMAIL_PAYMENT_REQUIRED": "Email transcript is not available on your current plan. Please upgrade to use this feature.",
    "FORM": {
      "SEND_TO_CONTACT": "إرسال نص المحادثة إلى العميل",
      "SEND_TO_AGENT": "إرسال نص المحادثة إلى وكيل خدمة العملاء المعين",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "إرسال النص إلى عنوان بريد إلكتروني آخر",
      "EMAIL": {
        "PLACEHOLDER": "أدخل عنوان بريد إلكتروني",
        "ERROR": "الرجاء إدخال عنوان بريد إلكتروني صحيح"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "اهلاً 👋، مرحباً بك في {installationName}!",
    "DESCRIPTION": "شكرا للتسجيل. نريدك أن تحصل على أقصى استفادة من {installationName}. إليك بعض الأشياء التي يمكنك القيام بها في {installationName} لجعل التجربة رائعة.",
    "GREETING_MORNING": "👋 صباح الخير، {name}. مرحبا بك في {installationName}.",
    "GREETING_AFTERNOON": "👋 مساء الخير، {name}. مرحبا بك في {installationName}.",
    "GREETING_EVENING": "👋 مساء الخير، {name}. مرحبا بك في {installationName}.",
    "READ_LATEST_UPDATES": "اطلع على آخر التحديثات",
    "ALL_CONVERSATION": {
      "TITLE": "جميع محادثاتك في مكان واحد",
      "DESCRIPTION": "عرض جميع المحادثات من عملائك في لوحة تحكم واحدة. يمكنك تصفية المحادثات حسب القناة الواردة والتسمية والحالة.",
      "NEW_LINK": "انقر هنا لإنشاء صندوق وارد"
    },
    "TEAM_MEMBERS": {
      "TITLE": "قم بدعوة أعضاء فريقك",
      "DESCRIPTION": "عندما تصبح جاهز للتخاطب مع عميلك، احضر زملائك في الفريق لمساعدتك. يمكنك دعوة زملائك في الفريق بإضافة عنوان البريد الإلكتروني الخاص بهم إلى قائمة الوكلاء.",
      "NEW_LINK": "انقر هنا لدعوة عضو في الفريق"
    },
    "LABELS": {
      "TITLE": "تنظيم المحادثات مع التسميات",
      "DESCRIPTION": "التسميات توفر طريقة أسهل لتصنيف محادثتك. إنشاء بعض التسميات مثل #كبار_العملاء، #العملاء_المحتملون الخ، بحيث يمكنك استخدامها في محادثة لاحقا.",
      "NEW_LINK": "انقر هنا لإنشاء وسوم"
    },
    "CANNED_RESPONSES": {
      "TITLE": "إدارة الردود الجاهزة",
      "DESCRIPTION": "الردود المسبقة هي قوالب رد مكتوبة مسبقاً تساعدك على الرد بسرعة على محادثة. يمكن للوكلاء كتابة حرف '/' يتبعه الرمز المختصر لإدراج رد مسبق أثناء محادثة.",
      "NEW_LINK": "انقر هنا لإنشاء استجابة مسبقة"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "الوكيل المكلف",
    "SELF_ASSIGN": "إسناد إلي",
    "TEAM_LABEL": "الفريق المكلف",
    "SELECT": {
      "PLACEHOLDER": "لا شيء"
    },
    "ACCORDION": {
      "CONTACT_DETAILS": "تفاصيل جهة الاتصال",
      "CONVERSATION_ACTIONS": "إجراءات المحادثة",
      "CONVERSATION_LABELS": "وسوم المحادثة",
      "CONVERSATION_INFO": "معلومات المحادثة",
      "CONTACT_NOTES": "Contact Notes",
      "CONTACT_ATTRIBUTES": "سمات جهة الاتصال",
      "PREVIOUS_CONVERSATION": "المحادثات السابقة",
      "MACROS": "ماكروس",
      "LINEAR_ISSUES": "Linked Linear Issues",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "SHARED_FILES": "Attachments"
    },
    "SHARED_FILES": {
      "EMPTY": "No attachments yet",
      "DOWNLOAD": "Download file",
      "DOWNLOAD_ERROR": "Could not download the file. Please try again.",
      "MEDIA_HEADING": "Media",
      "FILES_HEADING": "Files",
      "VIEW_ALL": "عرض الكل",
      "SHOW_LESS": "Show less",
      "MORE_COUNT": "+{count}",
      "UNTITLED_FILE": "Untitled file"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "معلق",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "إنشاء سمة جديدة",
    "NO_RECORDS_FOUND": "لم يتم العثور على سمات",
    "UPDATE": {
      "SUCCESS": "تم تحديث السمة المخصصة بنجاح",
      "ERROR": "غير قادر على تحديث السمة. الرجاء المحاولة مرة أخرى لاحقاً"
    },
    "ADD": {
      "TITLE": "إضافة",
      "SUCCESS": "تمت إضافة السمة بنجاح",
      "ERROR": "غير قادر على إضافة السمة. الرجاء المحاولة مرة أخرى لاحقاً"
    },
    "DELETE": {
      "SUCCESS": "تم حذف السمة المخصصة بنجاح",
      "ERROR": "غير قادر على حذف السمة. الرجاء المحاولة مرة أخرى لاحقاً"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "أضف سمة",
      "PLACEHOLDER": "البحث عن سمات",
      "NO_RESULT": "لم يتم العثور على سمات"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "من",
    "TO": "إلى",
    "BCC": "نسخة خفية من البريد",
    "CC": "نسخة من البريد",
    "SUBJECT": "الموضوع",
    "EXPAND": "Expand email"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "المشاركة",
    "SIDEBAR_TITLE": "المشاركون في المحادثة",
    "NO_RECORDS_FOUND": "لم يتم العثور على النتائج",
    "ADD_PARTICIPANTS": "اختر المشاركين",
    "REMANING_PARTICIPANTS_TEXT": "+{count} آخرون",
    "REMANING_PARTICIPANT_TEXT": "+{count} أخرى",
    "TOTAL_PARTICIPANTS_TEXT": "{count} شخص مشارك.",
    "TOTAL_PARTICIPANT_TEXT": "{count} شخص مشارك.",
    "NO_PARTICIPANTS_TEXT": "لا أحد يشارك!",
    "WATCH_CONVERSATION": "الانضمام إلى المحادثة",
    "YOU_ARE_WATCHING": "أنت مشترك",
    "API": {
      "ERROR_MESSAGE": "تعذر التحديث، حاول مرة أخرى!",
      "SUCCESS_MESSAGE": "تم تحديث المشاركين!"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "عرض المحتوى المترجم",
    "DESC": "يمكنك عرض المحتوى المترجم في كل لغة.",
    "ORIGINAL_CONTENT": "المحتوى الأصلي",
    "TRANSLATED_CONTENT": "المحتوى المترجم",
    "NO_TRANSLATIONS_AVAILABLE": "لا توجد ترجمات لهذا المحتوى"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
